import { FC } from 'react'
import { HRProps } from '@/presentation/common/components/types.ts'

export const HR: FC<HRProps> = ({ className }) => (
  <hr className={`my-2 ${className}`}/>
)
